import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import Logout from '@/components/Logout'

import Alimento from '@/components/alimento/Alimento'
import AlimentoHome from '@/components/alimento/AlimentoHome'
import AlimentoNew from '@/components/alimento/AlimentoNew'
import AlimentoEdit from '@/components/alimento/AlimentoEdit'

import AlimentoApp from '@/components/alimentoapp/Alimento'
import AlimentoAppHome from '@/components/alimentoapp/AlimentoHome'

import Solicitacao from '@/components/solicitacoes/Solicitacao'
import SolicitacaoHome from '@/components/solicitacoes/SolicitacaoHome'
import SolicitacaoNew from '@/components/solicitacoes/SolicitacaoNew'
import SolicitacaoEdit from '@/components/solicitacoes/SolicitacaoEdit'

import Users from '@/components/users/Users';
import UsersHome from '@/components/users/UsersHome';
import UsersNew from '@/components/users/UsersNew';
import UsersEdit from '@/components/users/UsersEdit';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  linkExactActiveClass: "active",
  routes: [
    {
      path: '/',
      redirect: '/calculadora',
    },
    {
      path: '/calculadora',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        humanName: 'Calculadora',
        showOnNav: true,
      }
    },
    {
      path: '/alimento',
      redirect: '/alimento/home',
      name: 'Alimento',
      component: Alimento,
      meta: {
        humanName: 'Alimentos',
        showOnNav: true
      },
      children: [
        {
          path: 'home',
          name: 'AlimentoHome',
          component: AlimentoHome,
          meta: {
            humanName: 'Listagem'
          },
        },
        {
          path: 'new',
          name: 'AlimentoNew',
          component: AlimentoNew,
          meta: {
            humanName: 'Novo'
          },
        },
        {
          path: 'edit/:id',
          name: 'AlimentoEdit',
          component: AlimentoEdit,
          meta: {
            humanName: 'Edição'
          },
        }
      ],
    },
    {
      path: '/alimentoapp',
      redirect: '/alimentoapp/home',
      name: 'AlimentoApp',
      component: AlimentoApp,
      meta: {
        humanName: 'Alimentos no App',
        showOnNav: true
      },
      children: [
        {
          path: 'home',
          name: 'AlimentoAppHome',
          component: AlimentoAppHome,
          meta: {
            humanName: 'Listagem'
          },
        },
      ],
    },
    {
      path: '/solicitacoes',
      redirect: '/solicitacoes/home',
      name: 'Solicitacao',
      component: Solicitacao,
      meta: {
        humanName: 'Solicitações',
        showOnNav: true
      },
      children: [
        {
          path: 'home',
          name: 'SolicitacaoHome',
          component: SolicitacaoHome,
          meta: {
            humanName: 'Listagem'
          },
        },
        {
          path: 'new',
          name: 'SolicitacaoNew',
          component: SolicitacaoNew,
          meta: {
            humanName: 'Novo'
          },
        },
        {
          path: 'edit/:id',
          name: 'SolicitacaoEdit',
          component: SolicitacaoEdit,
          meta: {
            humanName: 'Edição'
          },
        }
      ],
    },
    // USERS
    {
      path: '/users',
      redirect: '/users/home',
      name: 'Users',
      component: Users,
      meta: {
        humanName: 'Usuários',
        showOnNav: true
      },
      children: [
        {
          path: 'home',
          name: 'UsersHome',
          component: UsersHome,
          meta: {
            humanName: 'Listar'
          },
        },
        {
          path: 'new',
          name: 'UsersNew',
          component: UsersNew,
          meta: {
            humanName: 'Novo'
          },
        },
        {
          path: 'edit/:id',
          name: 'UsersEdit',
          component: UsersEdit,
          meta: {
            humanName: 'Editar'
          },
        }
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js